<template>
    <home-page></home-page>
</template>

<script>

    import HomePage from '@/HomePage/HomePageDownView.vue';

    export default {
        name: 'HomeLayout',
        components: {
            'home-page': HomePage
        }
    }
</script>


// WEBPACK FOOTER //
// HomeLayout.vue?67d1aae1